const GET_CURRENT_ANNOUNCEMENT = 'dofe-bo/ANNOUNCEMENT/GET_CURRENT_ANNOUNCEMENT'
const GET_CURRENT_ANNOUNCEMENT_SUCCESS = 'dofe-bo/ANNOUNCEMENT/GET_CURRENT_ANNOUNCEMENT_SUCCESS'
const GET_CURRENT_ANNOUNCEMENT_FAIL = 'dofe-bo/ANNOUNCEMENT/GET_CURRENT_ANNOUNCEMENT_FAIL'

const UPDATE_ANNOUNCEMENT = 'dofe-bo/ANNOUNCEMENT/UPDATE_ANNOUNCEMENT'
const UPDATE_ANNOUNCEMENT_SUCCESS = 'dofe-bo/ANNOUNCEMENT/UPDATE_ANNOUNCEMENT_SUCCESS'
const UPDATE_ANNOUNCEMENT_FAIL = 'dofe-bo/ANNOUNCEMENT/UPDATE_ANNOUNCEMENT_FAIL'

const initialState = {
  loading: false,
  loaded: false,
  detail: null
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_CURRENT_ANNOUNCEMENT:
      return {
        ...state,
        loading: true
      }
    case GET_CURRENT_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        detail: action.result
      }
    case GET_CURRENT_ANNOUNCEMENT_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case UPDATE_ANNOUNCEMENT:
      return {
        ...state,
        loading: true
      }
    case UPDATE_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        detail: action.result
      }
    case UPDATE_ANNOUNCEMENT_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    default:
      return state
  }
}


export function getCurrentAnnouncementByName(name = 'planned_maintenance') {

  const data = { name }

  return {
    types: [GET_CURRENT_ANNOUNCEMENT, GET_CURRENT_ANNOUNCEMENT_SUCCESS, GET_CURRENT_ANNOUNCEMENT_FAIL],
    promise: client => client.get(`api/system/announcement/content/get`, { data })
  }
}

export function getCurrentAnnouncement(id = 1) {
  const data = {}
  return {
    types: [GET_CURRENT_ANNOUNCEMENT, GET_CURRENT_ANNOUNCEMENT_SUCCESS, GET_CURRENT_ANNOUNCEMENT_FAIL],
    promise: client => client.get(`apiv2/system/announcement/${id}/get`, { data })
  }
}


export function updateAnnouncement(id, data) {
  return {
    types: [UPDATE_ANNOUNCEMENT, UPDATE_ANNOUNCEMENT_SUCCESS, UPDATE_ANNOUNCEMENT_FAIL],
    promise: client => client.post(`apiv2/system/announcement/${id}/update`, { data })
  }
}